<template>
  <div class="course-detail-page">
    <div class="course-container">
      <div class="course-title">
        <span>第 <i>0</i> 课</span>
        <span>走进智慧农场</span>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="讲义" name="first">
          <div v-loading="loadingpptx" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <iframe @load="loadingpptx = false" width="100%" height="800px" src="https://view.officeapps.live.com/op/view.aspx?src=https://wup-oss-1252338237.cos.ap-shanghai.myqcloud.com/api/20201102/a5a0f20a92604cda8d73c6c5a071c41b.pptx" frameborder="0"></iframe>
          </div>
        </el-tab-pane>
        <el-tab-pane label="课件" name="second">
          <div  v-loading="loadingpdf" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.5)">
            <iframe width="100%" height="800px" @load="loadingpdf = false" src="https://wup-oss-1252338237.cos.ap-shanghai.myqcloud.com/api/20201102/2d254ddc0cfd4cdc878ee9134149879f.pdf" frameborder="0"></iframe>
          </div>
        </el-tab-pane>
        <el-tab-pane label="视频" name="third">
          <div  v-loading="loadingvideo" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.5)">
            <video   controlslist="nodownload"
                     :disablePictureInPicture="true" width="100%" height="800px"  @canplay="loadingvideo = false" controls src="https://wup-oss-1252338237.cos.ap-shanghai.myqcloud.com/api/20201102/b7f63d8d6e5e49c4a42fa5d51119c465.mp4"></video>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      loadingpptx: true,
      loadingpdf: true,
      loadingvideo: true
    }
  },
  methods: {
    //
  }
}
</script>

<style lang="scss">
.course-container {
  position: relative;
  .course-title {
    position: absolute;
    top: 0;
    left: 0;
    line-height: 40px;
  }
  .el-tabs__nav-scroll {
    .el-tabs__nav {
      float: right;
    }
  }
  iframe, video {
    outline: none;
  }
}

// #AppHeaderPanel, #ReadingToolbarPanel {
//   display: none;
// }
</style>
